// @ts-ignore
import enLocale from "numerous/locales/en";
import * as numerous from "numerous";

numerous.registerLocale(enLocale);

export const capitalize = (str: string) => str.charAt(0).toUpperCase() + str.slice(1);

/** `max` counts the ellipsis. */
export const truncate = (str: string, max: number) =>
  str.length > max ? `${str.slice(0, Math.max(0, max - 1)).trimEnd()}…` : str;

/** "2.0.0 (a5a295e)", degrading to whichever half is there, or "" for neither. */
export const formatVersionWithHash = (version?: string | null, hash?: string | null) => {
  const v = version?.trim() ?? "";
  const h = hash?.trim() ?? "";
  if (v && h) return `${v} (${h})`;
  return v || h;
};

export const pluralize = ({
  one,
  other,
  count,
  zero,
}: {
  one: string;
  other: string;
  count: number;
  zero?: string;
}) => {
  if (count === 0 && zero) return zero;
  return numerous.pluralize("en", count, { one, other });
};

/**
 * Legacy `<br>` markup in old case payloads back to newlines, so the text renders as plain
 * text inside a `whitespace-pre-wrap` container.
 */
export const asMultilineText = (value: string) => value.replace(/<br\s*\/?>/gi, "\n");
